module.exports = __webpack_public_path__ + "img/master_card.e9e1bcae.png";